import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../../constants/svgIcon';
import { Locale } from '../../../../models/Base';
import { EvaluationType } from '../../../../models/GameControllerStore';
import {
  GameRecord,
  InAppEvaluation,
  TextEvaluationWord,
} from '../../../../models/RecordStore';
import { getTimeString } from '../../../../utils/date';
import {
  AppBar,
  GameActionButton,
  GameActionButtonVariant,
  SvgIcon,
} from '../../../Molecules';
import { AnalysisTextEvaluationPanel } from '../../../Organisms';

import styles from './GameAnalysisTemplate.module.css';

type GameAnalysisTemplateProps = {
  // onClickBack: () => void;
  latestRecord: GameRecord | undefined;
  answerLocale: Locale;
  isUseTranslate: boolean;
  originalLanguage: string;
  translatedLanguage: string;
  originalAudioTts: string | null | undefined;
  translatedAudioTts: string | null | undefined;
  translationResult: string | undefined;
  isHandwriting: boolean;
  onClickPlayGame: () => void;
  onSwitchTranslate: () => void;
  onClickLanguage: () => void;
  onClickMemoryHelper: () => void;
};

export const GameAnalysisTemplate = (props: GameAnalysisTemplateProps) => {
  const { t } = useTranslation();

  const {
    latestRecord,
    answerLocale,
    isUseTranslate,
    originalLanguage,
    translatedLanguage,
    originalAudioTts,
    translatedAudioTts,
    translationResult,
    isHandwriting,
    onClickPlayGame,
    onSwitchTranslate,
    onClickLanguage,
    onClickMemoryHelper,
  } = props;

  const evaluation = latestRecord?.evaluation;
  const recordScore = latestRecord?.score;
  const recordDuration = latestRecord?.durationInMs
    ? getTimeString(latestRecord?.durationInMs, 'HH:mm:ss.SS', true)
    : undefined;

  const resultAnalysisEvaluation:
    | InAppEvaluation<TextEvaluationWord>
    | undefined = evaluation
    ? {
        ...evaluation,
        inApp: evaluation?.inApp.map(
          (e) =>
            new TextEvaluationWord({ ...e, records: e.records.slice(0, 1) }),
        ),
        improvement: evaluation?.improvement?.map(
          (e) =>
            new TextEvaluationWord({ ...e, records: e.records.slice(0, 1) }),
        ),
      }
    : undefined;

  return (
    <div className={styles.screen}>
      <AppBar title={t('Analysis')} />
      <div className={styles.content}>
        {resultAnalysisEvaluation ? (
          <AnalysisTextEvaluationPanel
            recordScore={recordScore}
            recordDuration={recordDuration}
            evaluation={resultAnalysisEvaluation}
            evaluationKey={EvaluationType.InApp}
            answerLocale={answerLocale}
            isUseTranslate={isUseTranslate}
            originalLanguage={originalLanguage}
            translatedLanguage={translatedLanguage}
            originalAudioTts={originalAudioTts}
            translatedAudioTts={translatedAudioTts}
            translationResult={translationResult}
            isGameEnd={false}
            isHandwriting={isHandwriting}
            onSwitchTranslate={onSwitchTranslate}
            onClickLanguage={onClickLanguage}
          />
        ) : (
          <p>No Record</p>
        )}
        <div
          className={styles.memoryHelperButton}
          onClick={onClickMemoryHelper}
        >
          <SvgIcon name={SVGIconType.MemoryHelper} width={24} height={24} />
          <div className={styles.memoryHelperText}> {t('Memory Helper')}</div>
          <SvgIcon name={SVGIconType.Arrow} width={16} height={16} />
        </div>
      </div>
      <div className={styles.bottomBar}>
        <GameActionButton
          variant={GameActionButtonVariant.Green}
          onClick={onClickPlayGame}
          leading={
            <SvgIcon
              name={SVGIconType.Retry}
              width={24}
              height={24}
              color="white"
            />
          }
          trailing={
            <SvgIcon
              name={SVGIconType.Arrow}
              width={18}
              height={18}
              color="white"
            />
          }
        >
          <p style={{ padding: '0 1rem' }}>{t('Play Again')}</p>
        </GameActionButton>
      </div>
    </div>
  );
};
